import type { Surface } from "../domain";

const crewSurfaces = new Set<Surface>(["pulse", "manager", "board"]);

function crewRouteSegments(pathname: string) {
  const segments = pathname.split("/").filter(Boolean);
  return segments.length >= 3 && segments[0] === "crew" ? segments : null;
}

export function crewIdFromPathname(pathname: string): string | null {
  const segments = crewRouteSegments(pathname);
  if (!segments) return null;
  try {
    return decodeURIComponent(segments[1]) || null;
  } catch {
    return null;
  }
}

export function crewSurfaceFromPathname(pathname: string): Surface | null {
  const segments = crewRouteSegments(pathname);
  if (!segments) return null;
  const surface = segments[2] as Surface;
  return crewSurfaces.has(surface) ? surface : null;
}

export function crewSurfacePath(crewId: string, surface: Surface = "pulse") {
  return `/crew/${encodeURIComponent(crewId)}/${surface}`;
}
